/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import tw from 'twin.macro'
import styled from '@emotion/styled'
import { FontAwesomeSvgIcon } from 'react-fontawesome-svg-icon'
import { faEnvelope as mailIcon, faLocationDot as locationIcon } from '@fortawesome/pro-light-svg-icons'
import * as sH from 'sanitize-html'
import Obfuscate from 'react-obfuscate'
import ContactItem from './Contact/ContactItem'

const Contact = ({ data }) => {
  const { address, email, subtitle, title, contacts } = data

  const Container = styled.div`
    ${tw`text-white mx-auto max-w-5xl px-4 py-20 w-full`}
  `
  const Header = styled.header`
    ${tw`px-4 block md:flex justify-between mb-8`}
  `
  const TitleWrapper = styled.div`
    ${tw`mb-8`}
  `
  const Title = styled.h1`
    ${tw`text-4xl md:text-5xl lg:text-6xl text-ricoDarkGray mb-5 font-light`}
  `
  const Leading = styled.p``

  const Address = styled.address``

  const Table = styled.table`
    ${tw`table-auto align-middle mb-8`}
  `
  const Tbody = styled.tbody`
    ${tw``}
  `
  const Row = styled.tr``

  const Cell = styled.td`
    ${tw`py-2`}
    &:first-of-type {
      ${tw`text-center pr-6`}
    }
  `
  const CellContent = styled.div`
    ${tw`text-base text-left text-black not-italic`}
  `
  const Email = styled(props => <Obfuscate {...props} />)`
    ${tw`text-base text-black not-italic`}
  `
  const Contacts = styled.div`
    ${tw`mx-auto w-full md:grid md:grid-cols-2 lg:grid-cols-2 max-w-5xl auto-rows-max`}
  `
  const Empty = styled.div`
    ${tw`px-4 text-ricoBlack`}
  `
  const Icon = styled(props => <FontAwesomeSvgIcon {...props} />)`
    ${tw`text-4xl text-primary`}
  `
  const { t } = useTranslation()

  return (
    <Container>
      <Header>
        <TitleWrapper>
          {title && <Title dangerouslySetInnerHTML={{ __html: sH(title) }} />}
          {subtitle && <Leading className="prose prose-lg" dangerouslySetInnerHTML={{ __html: sH(subtitle) }} />}
        </TitleWrapper>
        <Address>
          <Table>
            <Tbody>
              {address && (
                <Row>
                  <Cell>
                    <Icon icon={locationIcon} />
                  </Cell>
                  <Cell>
                    <CellContent dangerouslySetInnerHTML={{ __html: sH(address) }} />
                  </Cell>
                </Row>
              )}
              {email && (
                <Row>
                  <Cell>
                    <Email email={email}>
                      <Icon icon={mailIcon} />
                    </Email>
                  </Cell>
                  <Cell>
                    <Email email={email}>
                      <CellContent dangerouslySetInnerHTML={{ __html: sH(email) }} />
                    </Email>
                  </Cell>
                </Row>
              )}
            </Tbody>
          </Table>
        </Address>
      </Header>
      <Contacts>
        {contacts && contacts?.length > 0 ? (
          contacts?.map(c => <ContactItem item={c} key={c.id} />)
        ) : (
          <Empty>{t('Inget att visa')}</Empty>
        )}
      </Contacts>
    </Container>
  )
}

Contact.propTypes = {
  title: PropTypes.string,
}

Contact.defaultProps = {
  title: 'Fler nyheter',
}

export default Contact

export const contactData = graphql`
  fragment Contact on WpPage_Pagebuilder_Layouts_Contact {
    fieldGroupName
    address
    email
    subtitle
    title
    contacts {
      ...PersonPreviewContent
    }
  }
`
